import "./index.scss";
import { __ } from '@wordpress/i18n';
import { useBlockProps } from "@wordpress/block-editor";
import { registerBlockType } from "@wordpress/blocks";
import { useEffect, useState } from '@wordpress/element';
import apiFetch from '@wordpress/api-fetch';
import metadata from "./block.json";

registerBlockType(metadata.name, {...metadata, edit: EditComponent });

function EditComponent() {
    const blockProps = useBlockProps();
    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        apiFetch({
            path: '/custom/v1/featured-formacoes'
        }).then((posts) => {
            setPosts(posts);
            setLoading(false);
        });
    }, []);

    return (
        <div {...blockProps}>
            <section className="container-fluid px-0">
                <div className="pbmit-element-posts-wrapper row multi-columns-row pbmit-element-service-style-4 mx-0">
                    {loading && <p>Loading...</p>}
                    {!loading && posts.length === 0 && <p>No posts found.</p>}
                    {!loading && posts.map((post, index) => (
                        <article key={post.id} className="pbmit-ele pbmit-ele-service pbmit-service-style-4 col-md-12 inovacao pbmit-term-20 pbmit-active">
                            <div className="pbminfotech-post-item">
                                {post.featured_media && (
                                    <div className="pbmit-service-img-wrapper" style={{ backgroundImage: `url(${post.featured_media})` }}>
                                        <div className="pbmit-featured-img-wrapper">
                                            <div className="pbmit-featured-wrapper">
                                                <img src={post.featured_media} alt={post.title} />
                                            </div>
                                        </div>
                                    </div>
                                )}
                                <div className="pbminfotech-box-content">
                                    <div className="pbmit-content-inner">
                                        <div className="pbminfotech-box-number">
                                            {index < 9 ? '0' + (index + 1) : (index + 1)}
                                        </div>
                                        <div className="pbmit-cat-wrap">
                                            <div className="pbmit-serv-cat">
                                                {post.categories && post.categories.map(term => (
                                                    <a key={term.id} href={term.link} rel="tag">
                                                        {term.name}
                                                    </a>
                                                ))}
                                            </div>
                                            <h3 className="pbmit-service-title">
                                                {post.title}
                                            </h3>
                                        </div>
                                    </div>
                                    <div className="pbmit-svg-btn">
                                        <a className="btn-arrow stretched-link" href={post.link} title={post.title}>
                                            <svg className="pbmit-svg-arrow" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="10" height="19" viewBox="0 0 19 19" xmlSpace="preserve">
                                                <line x1="1" y1="18" x2="17.8" y2="1.2"></line>
                                                <line x1="1.2" y1="1" x2="18" y2="1"></line>
                                                <line x1="18" y1="17.8" x2="18" y2="1"></line>
                                            </svg>
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <a href={post.link} className="stretched-link">
                                <span className="visually-hidden">
                                    Saber mais sobre o curso
                                </span>
                            </a>
                        </article>
                    ))}
                </div>
            </section>
        </div>
    );
}
